import { request } from "@/utils/request";
import { validatenull } from "@/utils/validate.js";
// const BASE_URL = `https://testservice.ehanghai.cn/ehh-api`;
const BASE_URL = `https://hhzx.ehanghai.cn/ehh-api`;
// 获取颜色列表
export function get_wind_zLevel_colors() {
  return request(
    `${BASE_URL}` +
      "/weather/prod/weather_color_manage/v1/get_wind_zlevel_colors",
    {
      method: "get",
    },
  );
}

/**
 * 渔区预报时间列表v1
 */
export function getAreaForecastTimes(params) {
  return request(
    `${BASE_URL}` +
      "/weather/prod/fishing_area/forecast/v1/get_areas_with_six_hour_forecast",
    {
      params,
    },
  );
}

/**
 * 获取全渔区气象值json文件
 */
export function getForecastData(url) {
  return request(url, {
    withCredentials: false, // 不允许携带凭证
    method: "get",
  });
}

/**
 * 获取渔场气象列表v1(6小时预报一次数据: 格式；上午、下午、上半夜、下半夜)
 */
export function getAreasWithSixHourForecast(params) {
  return request(
    `${BASE_URL}` +
      "/weather/prod/fishing_ground/forecast/v1/get_areas_with_six_hour_forecast",
    {
      method: "get",
      params,
      transformResponse: function (data) {
        const map = {};
        const datetimeSet = new Set();
        const responseData = JSON.parse(data);
        if (responseData.errorcode === 1015) {
          const error = new Error(responseData.reason);
          error.response = { data: responseData.reason };
          throw error;
        }
        // h5 request 返回响应体本身，业务数据在 result 字段下
        const result = responseData.result || responseData.data || {};
        for (let values of result.v || []) {
          const areaCode = values[4];
          const list = values[5];
          const datetimeMap = {};

          for (let datetimeItem of list) {
            const [forecastTime, windLevel, windZLevel, windDirection, wave] =
              datetimeItem;
            if (!validatenull(windLevel)) {
              datetimeMap[forecastTime] = {
                windLevel,
                windZLevel,
                windDirection,
                wave,
              };
              datetimeSet.add(forecastTime);
            }
          }
          map[areaCode] = datetimeMap;
        }

        return {
          dataset: map,
          datetimeList: Array.from(datetimeSet),
          responseData: result,
        };
      },
    },
  );
}

/**
 * 获取海区气象列表v1(每个海区包含6小时预报一次数据,如：上午、下午、上半夜、下半夜)
 */
export function getSeaAreasWithSixHourForecast(params) {
  return request(
    `${BASE_URL}` +
      "/weather/prod/sea_area/forecast/v1/get_areas_with_six_hour_forecast",
    {
      method: "get",
      params,
      transformResponse: function (data) {
        const map = {};
        const datetimeSet = new Set();
        const responseData = JSON.parse(data);
        if (responseData.errorcode === 1015) {
          const error = new Error(responseData.reason);
          error.response = { data: responseData.reason };
          throw error;
        }
        // h5 request 返回响应体本身，业务数据在 result 字段下
        const result = responseData.result || responseData.data || {};
        for (let values of result.v || []) {
          const areaCode = values[4];
          const list = values[5];
          const datetimeMap = {};

          for (let datetimeItem of list) {
            const [forecastTime, windLevel, windZLevel, windDirection, wave] =
              datetimeItem;
            if (!validatenull(windLevel)) {
              datetimeMap[forecastTime] = {
                windLevel,
                windZLevel,
                windDirection,
                wave,
              };
              datetimeSet.add(forecastTime);
            }
          }
          map[areaCode] = datetimeMap;
        }
        return {
          dataset: map,
          datetimeList: Array.from(datetimeSet),
          responseData: result,
        };
      },
    },
  );
}

// 获取大风列表(6小时刻度)v1
export function get_areas_with_six_hour_forecast() {
  return request(
    `${BASE_URL}` +
      "/weather/prod/big_wind/forecast/v1/get_areas_with_six_hour_forecast",
    {},
  );
}

export function getJson(url) {
  return request(url, {
    withCredentials: false, // 不允许携带凭证
  });
}

// 渔区编码获取预报v1
export function fishing_area_get_area_forecast_detail(params) {
  return request(
    `${BASE_URL}` +
      "/weather/prod/fishing_area/forecast/v1/get_detail_with_six_hour_forecast",
    {
      method: "get",
      params,
    },
  );
}

// 渔场获取预报v1
export function fishing_ground_get_area_forecast_detail(params) {
  return request(
    `${BASE_URL}` +
      "/weather/prod/fishing_ground/forecast/v1/get_area_forecast_detail",
    {
      method: "get",
      params,
    },
  );
}

// 获取海区预报详情v1
export function sea_area_get_area_forecast_detail(params) {
  return request(
    `${BASE_URL}` +
      "/weather/prod/sea_area/forecast/v1/get_area_forecast_detail",
    {
      method: "get",
      params,
    },
  );
}
// 获取港口列表v2
export function get_all_tide_station() {
  return request(`${BASE_URL}/poi/prod/sea_poi/v1/get_all_tide_station`, {
    method: "get",
  });
}
// 获取港口潮汐预报v1
export function get_station_tide(code) {
  return request(`${BASE_URL}/weather/prod/tide_forecast/v1/get_station_tide`, {
    method: "get",
    params: { code },
  });
}
